{
  "(optional)": "(facoltativo)",
  "(required)": "(obbligatorio)"
}